<template>
    <v-col cols="12" xl="10" class="px-0">
        <v-form ref="passwordReset" v-model="isValid">
            <v-row>
                <v-col cols="12" lg="4">
                    <h5>{{ t('dms-users::form.label.role') }}</h5>
                    <v-divider></v-divider>
                    <v-chip-group v-if="roles" column>
                        <v-chip v-for="(role, index) in roles" :key="index" small>
                            {{ role.name }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
                <v-col cols="12" lg="4">
                    <h5>{{ t('dms-users::form.label.pharmacy_group') }}</h5>
                    <v-divider></v-divider>
                    <v-chip-group v-if="pharmacyGroup" column>
                        <v-chip v-if="pharmacyGroup" small>
                            {{ pharmacyGroup.group_name }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
                <v-col cols="12" lg="4">
                    <h5>{{ t('dms-users::form.label.pharmacy_sites') }}</h5>
                    <v-divider></v-divider>
                    <v-chip-group v-if="pharmacySites" column>
                        <v-chip v-for="(site, index) in pharmacySites" :key="index" small>
                            {{ site.site_name }}
                        </v-chip>
                    </v-chip-group>
                </v-col>

                <v-col v-if="has_all_sites_and_groups_deleted" cols="12" class="py-0">
                    <b-alert type="error" :message="t('dms-users::profile.status.no_permissions.info')"> </b-alert>
                </v-col>

                <v-col cols="12">
                    <h5 class="m-0">{{ t('dms-users::form.title.change_password') }}</h5>
                    <v-divider class="mt-5 mb-3"></v-divider>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <b-input
                        to-mutate="dms_users::password.password"
                        :label="t('dms-users::form.label.old_password')"
                        type="password"
                    ></b-input>
                </v-col>
                <v-col cols="12" md="6" class="py-0"> </v-col>
                <v-col cols="12" md="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::password.new_password"
                        :label="t('dms-users::form.label.new_password')"
                        type="password"
                    ></b-input>
                </v-col>
                <v-col cols="12" md="6" class="pt-0">
                    <b-input
                        to-mutate="dms_users::password.new_password_confirmation"
                        :label="t('dms-users::form.label.confirm_password')"
                        type="password"
                    ></b-input>
                </v-col>
            </v-row>
        </v-form>
    </v-col>
</template>

<script>
export default {
    name: 'DmsUserPasswordChange',
    data() {
        return {
            isValid: false,
        };
    },
    computed: {
        roles() {
            return _.get(this.$store.state.dms_users, 'dms_user.roles');
        },
        pharmacyGroup() {
            return _.get(this.$store.state.dms_users, 'dms_user.pharmacy_group');
        },
        pharmacySites() {
            return _.get(this.$store.state.dms_users, 'dms_user.pharmacy_sites');
        },
        has_all_sites_and_groups_deleted() {
            return _.get(this.$store.state.dms_users, 'dms_user.has_all_sites_and_groups_deleted');
        },
    },
    methods: {},
};
</script>

<style></style>
